import React from 'react';
import { Container, Button } from 'reactstrap';
import {Card, CardBody, CardHeader, CardFooter, CardImg, CardSubtitle, CardTitle, CardText} from 'reactstrap';


const Course=({course})=>{
    return(
        <div>
             <Card>
                <CardBody>
                    <CardTitle className='fw-bold'>{course.title} </CardTitle>
                    <CardText>{course.description} </CardText>
                    <Container>
                        <Button color="warning ">Update</Button>
                        
                        <Button color="danger ms-3">Delete</Button>
                    </Container>
                </CardBody>
            </Card>
        </div>
    );
}

export default Course;


//className="text-center" or className="text-right"
//className='font-weight-bold'
// className='ml-3'
// color="warning ml-3"